export default "__VITE_ASSET__B0viQA8O__"